var classes = {"productListHero":"_3aifI","productListHeroPaddings":"xA2z-","productListHeroInnerWrapper":"GvaJ7","productListHeroImageAspectRatio":"Sdu7N","productListHeroProducts":"Kj7ux","productListHeroContentWrapper":"FVM8l","productListHeroCopyCTAWrapper":"AqXJ-"};

export { classes as default };
